export const statusSubscribe = {
  CREATED: 'Создана',
  ACTIVE: 'Активная',
  CANCELED: 'Деактивирована',
  LIMIT_ATTEMPT_EXCEEDED: 'Приостановлена системой',
};
